<template>
  <div class="content" style="min-height: 100vh; overflow: auto">
    <!-- <div class="d-flex-s">
      <div
        v-for="(item, index) in MenList"
        :key="index"
        @click="goToMen(index)"
        :class="{ 'select-Men': selectMenIndex === index }"
        style="width: 50%; border-bottom: 1px solid #d1e6e2"
      >
        <div class="d-flex" style="justify-content: center; padding: 12px 0">
          <img :src="item.img" width="30" class="m-r-5" />
          <p class="f-t-15 f-w">{{ item.name }}</p>
        </div>
      </div>
    </div> -->
    <div class="mask-cont m-t-10">

      <!-- <div
        class="d-flex"
        style="
          width: 95%;
          margin: 5px auto;
          justify-content: space-between;
          overflow: auto;
        "
      >
        <img
          v-for="(item, index) in [
            `https://file.otgame.bet/static/${getCurrency}/10.png`,
            `https://file.otgame.bet/static/${getCurrency}/11.png`,
            `https://file.otgame.bet/static/${getCurrency}/12.png`,
            `https://file.otgame.bet/static/${getCurrency}/13.png`,
            `https://file.otgame.bet/static/${getCurrency}/14.png`
          ]"
          :key="index"
          :src="item"
          width="31.5%"
          style="border-radius: 10px; margin-right: 10px"
          @click="gotoAc(index)"
        />
      </div> -->
      <!-- <div class="container">
        <common-swiper
          :slides="images"
          :interval="5000"
          :transitionDuration="1000"
          :showArrows="true"
          :showIndicators="true"
        >
          <template #default="{ item }">
            <img
              :src="item"
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </template>
        </common-swiper>
      </div> -->
      <!-- <div class="content-jack">
        <div class="content-jack--c">
          <div class="content-jack--i">
            <div class="number-display">
              <div v-for="(char, index) in formattedNumber" :key="index">
                <img
                  :src="getImagePath(char)"
                  class="number-image"
                  :class="{ 'font-bd': ['.', ','].includes(char) }"
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="content-winner">
        <div class="d-flex">
          <img
            src="../../assets/img/common/game-icon.png"
            width="20px"
            style="margin-top: -2px"
          />
          <p class="f-t-15 m-l-5 f-w">{{ $lang.home_txt2 }}</p>
        </div>
        <!-- 自定义从左到右轮播：支持左右滑动、无限循环 -->
        <div
          class="winner-carousel-wrap"
          ref="winnerCarouselWrap"
          @touchstart="onWinnerTouchStart"
          @touchmove="onWinnerTouchMove"
          @touchend="onWinnerTouchEnd"
        >
          <div
            class="winner-carousel-track"
            :class="{ 'winner-carousel-no-transition': winnerNoTransition }"
            :style="winnerTrackStyle"
            ref="winnerCarouselTrack"
          >
            <div
              v-for="(item, index) in winnerDisplayList"
              :key="'winner-' + index"
              class="item-sider winner-carousel-item"
            >
              <div style="position: relative">
                <van-image
                  class="swiper-slide--img"
                  :src="item.gameIcon"
                  lazy-load
                  style="height: 82px"
                >
                  <template v-slot:loading>
                    <van-loading size="20" color="#a665d8" vertical />
                  </template>
                </van-image>

                <p
                  class="d-flex"
                  style="
                    position: absolute;
                    right: 0;
                    left: 0;
                    bottom: 2px;
                    margin: 0 auto;
                    font-size: 10px;
                    backdrop-filter: blur(10px) grayscale(30%);
                    height: 35px;
                    justify-content: center;
                    padding-bottom: 5px;
                    padding-top: 5px;
                    border-radius: 0 0 8px 8px;
                    color: #ffffff;
                    text-align: center;
                  "
                >
                  {{ item.gameName }}
                </p>
              </div>

              <div class="item-sider--t">
                <div class="d-flex" style="margin: 8px 0 0">
                  <img
                    src="../../assets/img/common/logo_winner.png"
                    width="10"
                  />
                  <p class="m-l-5">{{ item.userName }}</p>
                </div>
                <p class="primary-color content-winner--t">
                  {{ $formatNumberWithCommas(item.amount) || 0 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-serach" @click="$jumpTo('/searchGame')">
        <div class="search-entry-wrap">
          <img
            src="../../assets/img/common/ssk_com.png"
            width="18"
            class="search-entry-icon"
          />
          <span class="search-entry-placeholder">{{
            $lang.menu_search_placeholder
          }}</span>
        </div>
      </div>
      <div v-if="pgDate.dataList" class="content-tab" ref="targetElement">
        <div class="content-tab--s">
          <van-loading v-if="loading" color="#a665d8" vertical> </van-loading>
        </div>
        <van-tabs
          @click="tabSelect"
          v-model="activeTab"
          title-inactive-color="#ffffff"
          title-active-color="#ffffff"
          :ellipsis="false"
          lazy-render
        >
          <van-tab
            v-for="(item, index) in pgDate.dataList"
            :key="index + 'xx'"
          >
            <template #title>
              <div
                class="tab-title-column d-flex"
                :class="{ 'a-ccc': activeTab === index }"
              >
                <img :src="item.icon" class="tab-icon" />
                <span class="tab-text f-t-12 m-l-5">{{ item.name }}</span>
              </div>
            </template>

            <div
              class="content-tab--c"
              style="margin-left: 12px; margin-right: 12px"
            >
              <!-- sortType === 1: 厂商分类，只展示厂商icon列表 -->
              <div v-if="item.sortType === 1" class="vendor-grid">
                <div
                  v-for="(item2, index2) in item.types"
                  :key="index2"
                  class="vendor-grid__item"
                  @click="goVendor(item2)"
                >
                  <img :src="item2.icon" class="vendor-grid__icon" />
                </div>
              </div>
              <!-- sortType === 0 或 3: 普通游戏分类，正常展示 -->
              <div
                v-else
                v-for="(item2, index2) in item.types"
                :key="index2"
              >
                <!-- <div v-if="!allOpen" class="content-tab--ct d-flex m-b-10">
                <img :src="item2.icon" width="35" class="m-l-5" />

                <div
                  v-if="!allOpen && item2.games.length > 12"
                  class="d-flex content-tab--ctt"
                  style="color: #c4c4c4"
                  @click="openAll(item2, index2)"
                  :key="timer"
                >
                  <p class="m-r-5" style="color: #ffffff">{{ $lang.ALL }}</p>
                  <p class="content-tab--ctt2 f-w">
                    <span>{{ item2.games.length }}</span>
                  </p>
                </div>
              </div> -->
                <keep-alive>
                  <!-- <resher-siper
                  v-if="!allOpen"
                  :siderData="item2"
                  :siderIndex="index2"
                  @getBack="getBacks"
                ></resher-siper> -->
                  <resher-siper2
                    v-if="!allOpen"
                    :siderData="item2"
                    :siderIndex="index"
                    @getBack="getBacks"
                    ref="swipe2"
                  ></resher-siper2>
                </keep-alive>
              </div>
            </div>
            <!-- <keep-alive>
              <resher-content
                v-if="
                  item.types[typeIndex] &&
                  item.types[typeIndex].games.length > 12 &&
                  allOpen
                "
                :contData="item.types[typeIndex]"
              ></resher-content>
            </keep-alive> -->
          </van-tab>

          <div class="content-bbttom" style="padding: 20px 0 50px">
            <div style="width: 90%; margin: 0 auto">
              <p class="t-c">{{ $lang.common_txt358 }}</p>

              <div class="t-c m-t-20">
                <img
                  v-for="(item, index) in [
                    { src: require('@/assets/img/otgame/pinduoduo_21.png'), url: 'https://facebook.com' },
                    { src: require('@/assets/img/otgame/pinduoduo_24.png'), url: 'https://twitter.com' },
                    { src: require('@/assets/img/otgame/ins.png'), url: 'https://instagram.com' },
                    { src: require('@/assets/img/otgame/zjm_42.png'), url: 'https://tiktok.com' }
                  ]"
                  :key="index"
                  :src="item.src"
                  width="34"
                  class="m-l-10 m-r-10"
                  style="cursor: pointer;"
                  @click="openLink(item.url)"
                />
              </div>

              <!-- <img src="../../assets/img/common/logo_h.png" width="100" />
              <p class="m-t-10">
                {{ $lang.common_txt164 }}
              </p> -->

              <!-- <p class="content-line m-t-10"></p> -->
              <!-- <img src="../../assets/img/common/cmc_1.png" width="90%" /> -->
              <p class="content-line m-t-10"></p>

              <p class="t-c">{{ $lang.common_txt359 }}</p>

              <!-- <p class="m-t-20">{{ $lang.common_txt165 }}</p> -->
              <div class="t-c m-t-20">
                <img
                  v-for="(item, index) in [
                    { src: require('@/assets/img/otgame/group-chat.png'), url: 'https://t.me/OTGAME777' },
                    { src: require('@/assets/img/otgame/channel.png'), url: 'https://t.me/OTgamel' }
                  ]"
                  :key="index"
                  :src="item.src"
                  width="34"
                  class="m-l-10 m-r-10"
                  style="cursor: pointer;"
                  @click="openLink(item.url)"
                />
              </div>
              <p class="content-line m-t-10"></p>
              <p class="t-c">{{ $lang.common_txt360 }}</p>
              <div class="t-c m-t-20">
                <img src="../../assets/img/otgame/cooper.png" width="100%" />
              </div>

              <!-- <img
                class="m-t-10"
                src="../../assets/img/common/cmc_2.png"
                width="90%"
              /> -->
              <!-- <p class="content-line m-t-10"></p>
              <img
                class="m-t-10"
                src="../../assets/img/common/cmc_3.png"
                width="100%"
              /> -->
              <p class="content-line m-t-10"></p>
              <div class="t-c">
                <img src="../../assets/img/otgame/eighteen.png" width="34" />
                <p
                  style="color: #9294a9; font-size: 11px"
                  v-html="$lang.common_txt361"
                ></p>
              </div>
            </div>
          </div>
        </van-tabs>
      </div>
    </div>

    <!-- <menu-home></menu-home> -->
    <login v-model="showPopup" overlay></login>
    <!-- 大转盘 -->
    <lucky-roulette v-model="isShowPopup" overlay></lucky-roulette>

    <van-popup
      v-model="showDialog"
      class="custom-popup2"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <div class="cont-redim">
        <!-- <van-button
          @click="submit2"
          size="large"
          class="custom-button"
          style="width: 80%"
        >
          {{ $lang.home_txt9 }}
        </van-button> -->
        <!-- <div
          style="width: 55%; height: 58px; margin: 0 auto"
          @click="submit2"
        ></div> -->
      </div>
      <div class="d-flex-s m-t-10">
        <div class="d-flex">
          <van-checkbox
            v-model="agree"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: 11px">{{ $lang.home_txt7 }}</p>
        </div>
        <div class="d-flex">
          <van-checkbox
            v-model="agree2"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: 11px">{{ $lang.home_txt8 }}</p>
        </div>
      </div>
      <!-- <div v-if="isCountdownActive" class="counw-cont">
        <div>
          <div class="d-flex-s f-w">
            <p class="counw-cont-bg2">MIN</p>
            <p class="counw-cont-bg2">SEC</p>
          </div>
          <div class="d-flex-s">
            <p class="counw-cont-bg m-r-10">{{ formattedMinutes }}</p>
            <p class="f-w" style="font-size: 25px; color: #ffffff">:</p>
            <p class="counw-cont-bg m-l-10">{{ formattedSeconds }}</p>
          </div>
        </div>
      </div>  -->

      <img
        class="m-t-10"
        @click="closeF()"
        src="../../assets/img/lucky_jackpot/img_cancel.png"
        width="38"
      />
    </van-popup>
    <!-- 活动 -->
    <activity-popup
      v-model="isShowPopup2"
      @closeActive="closeActive"
      @closeActive2="closeActive2"
    ></activity-popup>
  </div>
</template>
<script>
import scrollIntoView from 'scroll-into-view-if-needed'
import {
  GetHomeWinningGameList,
  GetHomeGameList,
  GetIsFbReport,
  ActivitygetRegisterAward,
  GetPlatformList,
  GetInvitationID
} from '@/api/common'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
// import ResherSiper from '../../components/home/ResherSiper.vue'
import ResherSiper2 from '../../components/home/ResherSiper2.vue'
// import ResherContent from '../../components/home/ResherContent.vue'
// import MenuHome from '../../components/home/MenuHome.vue'
export default {
  name: 'home',
  // components: { ResherSiper, ResherContent, MenuHome },
  // components: { ResherSiper, ResherContent },
  // components: { ResherSiper2, ResherContent },
  components: { ResherSiper2 },

  data() {
    return {
      selectMenIndex: 1,
      MenList: [
        {
          img: require('@/assets/img/home/men_1.png'),
          name: this.$lang.common_txt138
        },
        {
          img: require('@/assets/img/home/men_2.png'),
          name: this.$lang.common_txt139
        }
      ],
      totalSeconds: 1800, // 30分钟 = 1800秒
      timer5: null,
      isCountdownActive: true,
      agree2: false,
      agree: false,
      isRegister: localStorage.getItem('isRegister'),
      showDialog: false,
      isShowPopup2: false,
      // currentValue: 10029898.87, // 初始值
      // numberImages: {
      //   0: require('@/assets/img/common/0.png'),
      //   1: require('@/assets/img/common/1.png'),
      //   2: require('@/assets/img/common/2.png'),
      //   3: require('@/assets/img/common/3.png'),
      //   4: require('@/assets/img/common/4.png'),
      //   5: require('@/assets/img/common/5.png'),
      //   6: require('@/assets/img/common/6.png'),
      //   7: require('@/assets/img/common/7.png'),
      //   8: require('@/assets/img/common/8.png'),
      //   9: require('@/assets/img/common/9.png'),
      //   ',': require('@/assets/img/common/10.png'),
      //   '.': require('@/assets/img/common/11.png')
      // },
      // timer2: null,
      isShowPopup: false,
      showPopup: false,
      itemWidth: 72, // 单个元素的宽度（单位：px）
      activeTab: 0,
      prizeAmount: 11002030,
      typeIndex: null,
      allOpen: false,
      loading: false,
      winDate: [],
      pgDate: {},
      // 自定义中奖轮播：偏移(px)、触摸起点、是否禁用过渡、自动播放定时器
      winnerOffsetX: 0,
      winnerTouchStartX: 0,
      winnerNoTransition: false,
      winnerAutoplayTimer: null,
      winnerItemWidth: 65,
      winnerGap: 10,
      timer: null,
      serachName: '',
      filteredDataList: [], // 过滤后的数据
      topHdlist: [
        {
          img: require('@/assets/img/common/top-2-1.png'),
          title: 'Sorteio Diário'
        },
        {
          img: require('@/assets/img/common/top-2-2.png'),
          title: 'Vip'
        },
        {
          img: require('@/assets/img/common/top-2-3.png'),
          title: 'Atividade'
        },
        {
          img: require('@/assets/img/common/top-2-4.png'),
          title: 'Compartilhar'
        }
      ],
      images: [
        require('@/assets/img/activity/banner0.png'),
        require('@/assets/img/activity/banner1.png'),
        require('@/assets/img/activity/banner2.png'),
        require('@/assets/img/activity/banner3.png')
        // require('@/assets/img/activity/banner4.png')
      ],
      btImgs: [
        {
          img: require('@/assets/img/common/logo_h.png'),
          name: 'Responsible GameBling'
        }
        // {
        //   img: require('@/assets/img/common/img_anb.png'),
        //   name: 'About'
        // },
        // {
        //   img: require('@/assets/img/common/img_do.png'),
        //   name: 'T&C’s FAQs'
        // }
      ],
      btImgs2: [
        require('@/assets/img/common/18_ss.png'),
        require('@/assets/img/common/tt_icon.png'),
        require('@/assets/img/common/whats-w.png'),
        require('@/assets/img/common/facebook.png'),
        require('@/assets/img/common/img_tt.png')
      ],
      // activeList: [
      //   require('@/assets/img/common/active1.png'),
      //   require('@/assets/img/common/active2.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg')
      // ],
      allItems: [],
      currentPage: 0,
      itemsPerPage: 5,
      timer3: null,
      isOtgame: []
    }
  },
  watch: {
    totalSeconds(newVal) {
      const currentTime = Math.floor(Date.now() / 1000)
      const newEndTime = currentTime + newVal
      localStorage.setItem('countdownEndTime', newEndTime)
    }
  },
  computed: {
    formattedMinutes() {
      return Math.floor(this.totalSeconds / 60)
    },
    formattedSeconds() {
      return this.formatNumber(this.totalSeconds % 60)
    },
    // formattedNumber() {
    //   // 格式化数字：句号代表千分位，逗号代表小数
    //   const parts = this.currentValue.toString().split('.')
    //   const integerPart = parts[0]
    //   const decimalPart = parts[1] || ''
    //   // 插入千分位句号
    //   const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    //   // 确保小数点后两位
    //   const formattedDecimal = decimalPart.padEnd(2, '0').slice(0, 2)
    //   // 组合结果
    //   return `${formattedInteger},${formattedDecimal}`.split('')
    // },
    displayedItems() {
      const start = this.currentPage * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.allItems.slice(start, end)
    },
    // 中奖轮播：原始列表、三份拼接用于无限循环、轨道样式
    winnerList() {
      return (this.winDate && this.winDate.dataList) || []
    },
    winnerDisplayList() {
      const list = this.winnerList
      if (!list.length) return []
      return [...list, ...list, ...list]
    },
    winnerTrackStyle() {
      const w = this.winnerItemWidth + this.winnerGap
      const total = this.winnerDisplayList.length * w
      return {
        width: total + 'px',
        transform: `translate3d(${this.winnerOffsetX}px, 0, 0)`
      }
    }
  },
  created() {
    this.GetInvitationID()
    // this.GetIsFbReport()
    this.GetHomeGameList()
    this.GetHomeWinningGameList()
  },
  async mounted() {
    this.GetPlatformList()
    // if (!this.GET_PLATFORM) {
    //   this.$router.replace('/Country')
    //   return
    // }
    this.initCountdown()
    // if (this.token) {
    // this.ActivitygetRegisterAward()
    // }
    // 检查今日不显示
    const today = new Date().toISOString().split('T')[0]
    // 检查今日不显示
    // if (sessionStorage.getItem('neverShowToday') === today) {
    //   this.isShowPopup2 = false
    // } else if (localStorage.getItem('neverShow')) {
    //   // 检查永久不显示
    //   this.isShowPopup2 = false
    // } else {
    //   this.isShowPopup2 = true
    // }

    if (sessionStorage.getItem('neverShowToday2') === today) {
      this.showDialog = false
    } else if (localStorage.getItem('neverShow2')) {
      // 检查永久不显示
      this.showDialog = false
    } else {
      // this.showDialog = true
    }
    // if (
    //   localStorage.getItem('isRegister') === 'isRegister' &&
    //   this.isShowPopup2 === false
    // ) {
    //   this.showDialog = true
    // this.resetCountdown()
    // }
    // this.startTimer()
    this.startTimer2()
    this.loadSavedValue()
    // if (this.$route.query.id) {
    //   await localStorage.setItem('id', this.$route.query.id)
    // }
    // await this.GetIsFbReport()
    // if (this.$route.query?.id && !this.token) {
    // if (this.$route.query?.id) {
    //   localStorage.setItem(
    //     'fbExpand',
    //     this.$pixel.getUrlFBParams().replace('#/home?', '&')
    //   )
    //   // this.showPopup = true
    // }
    this.$bus.$on('message-sent', (v) => {
      scrollIntoView(this.$refs.targetElement, {
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 垂直方向对齐方式
      })
      this.activeTab = v
    })
  },
  beforeDestroy() {
    if (this.timer2) {
      clearInterval(this.timer2)
    }
    if (this.timer) {
      clearInterval(this.timer3)
    }
    this.winnerStopAutoplay()
    this.$bus.$off('message-sent')
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    },
    async GetInvitationID() {
      const data = await GetInvitationID({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        if (data.content.invitCode) {
          localStorage.setItem('id', data.content.invitCode)
          setTimeout(() => {
            this.GetIsFbReport()
          }, 200)
        }
      }
    },
    async GetPlatformList() {
      const data = await GetPlatformList()
      if (data.status === 'ok') {
        const list = data.content.list || []
        const path = this.$route.path // 此时path的值是 "/NG/home"
        // 按/分割路径，过滤空字符串（避免开头/导致的空元素）
        const pathArr = path.split('/').filter((item) => item)
        // 分割后数组是 ["NG", "home"]，取第一个元素就是NG
        if (pathArr.length > 1) {
          let newArr = list.filter(
            (item) => item.country === pathArr[0]
          )
          if (newArr.length === 0) {
            return
          }
          const prevPlatform = localStorage.getItem('platform')
          logoutIfReloginRequiredWithToken(prevPlatform, newArr[0].platform)
          localStorage.setItem('currency', newArr[0].currency)
          localStorage.setItem('areaCode', newArr[0].areaCode)
          localStorage.setItem('currencyUnit', newArr[0].currencyUnit)
          localStorage.setItem('platform', newArr[0].platform)
          localStorage.setItem('defaultLanguage', newArr[0].defaultLanguage)
          localStorage.setItem('iconUrl', newArr[0].iconUrl)
          localStorage.setItem('countryName', newArr[0].countryName)
          localStorage.setItem('country', newArr[0].country)
          // setTimeout(() => {
          //   window.location.reload()
          // }, 200)
        }
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
    },
    // noticeText(dataArr) {
    //   if (dataArr) {
    //     return dataArr
    //       .map(
    //         (item) =>
    //           `${item.userName} : ${
    //             this.$lang.home_txt
    //           } ${this.$formatNumberWithCommas(item.amount)} ${
    //             this.$lang.BRL
    //           }  `
    //       )
    //       .join('  |  ') // 使用分隔符区分不同通知
    //   }
    // },
    gotoAc(i) {
      if (i === 0) {
        this.$jumpTo('/Crowdfunding')
      } else if (i === 1) {
        this.$jumpTo('/signIn')
      } else if (i === 2) {
        this.$jumpTo('/redPacket')
      } else if (i === 3) {
        this.$jumpTo('/referFriend')
      } else if (i === 4) {
        this.$jumpTo('/cashBack')
      }
    },
    serachGo() {
      this.$jumpTo('/category')
    },
    closeActive() {
      this.showDialog = false
    },
    closeActive2() {
      this.showDialog = true
    },
    async ActivitygetRegisterAward() {
      const data = await ActivitygetRegisterAward()
      if (data.status === 'ok') {
        if (data.content.receiveStatus === 1) {
          this.isShowPopup2 = true
        } else {
          this.isShowPopup2 = false
        }
      } else if (data.status === 'need_login') {
        this.isShowPopup2 = true
      }
    },
    resetCountdown() {
      // 重置倒计时
      this.stopCountdown()
      this.isCountdownActive = true
      this.totalSeconds = 1800 // 重置为30分钟
      const endTime = Math.floor(Date.now() / 1000) + this.totalSeconds
      localStorage.setItem('countdownEndTime', endTime)
      this.startCountdown()
    },
    formatNumber(num) {
      return num.toString().padStart(2, '0')
    },
    startCountdown() {
      this.timer5 = setInterval(() => {
        this.totalSeconds--

        if (this.totalSeconds <= 0) {
          this.stopCountdown()
          this.isCountdownActive = false
          localStorage.removeItem('countdownEndTime')
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.timer5) {
        clearInterval(this.timer5)
        this.timer5 = null
      }
    },
    initCountdown() {
      const storedEndTime = localStorage.getItem('countdownEndTime')

      if (storedEndTime) {
        const endTime = parseInt(storedEndTime)
        const currentTime = Math.floor(Date.now() / 1000)

        if (currentTime < endTime) {
          this.totalSeconds = endTime - currentTime
          this.startCountdown()
        } else {
          this.isCountdownActive = false
        }
      } else {
        const endTime = Math.floor(Date.now() / 1000) + this.totalSeconds
        localStorage.setItem('countdownEndTime', endTime)
        this.startCountdown()
      }
    },
    closeF() {
      if (this.agree) {
        // 今日不显示
        const today = new Date().toISOString().split('T')[0]
        sessionStorage.setItem('neverShowToday2', today)
      }
      if (this.agree2) {
        // 永久不显示
        localStorage.setItem('neverShow2', true)
      }
      this.showDialog = false
    },
    submit2() {
      localStorage.removeItem('isRegister')
      sessionStorage.removeItem('neverShowToday2')
      localStorage.removeItem('neverShow2')
      this.showDialog = false
      // this.$router.push('/recharge')
      if (this.token) {
        this.isShowPopup2 = false
        this.$jumpTo('/rechargeCont')
      } else {
        this.isShowPopup2 = false
        this.showPopup = true
      }
    },
    async GetIsFbReport() {
      const data = await GetIsFbReport({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        // 设置 Facebook Pixel ID
        if (data.content.isReport) {
          if (data.content.target === 'ks') {
            // window.kwaiq.load(data.content.fbPixId)
            // window.kwaiq.instance('279479691584322').track('addToCart')
            window.kwaiq.load(data.content.fbPixId)
            window.kwaiq.instance(data.content.fbPixId).track('contentView')
            // window.kwaiq.load('279479691584322')
            // window.kwaiq.track('contentView')
            // window.kwaiq.page()
            console.log('page')
          } else {
            console.log(123)

            this.$pixel.setFbId(data.content.fbPixId)
            this.$pixel.callTrack('track', 'ViewContent')
            const jsonData = `"""{"data":[{"event_name": "ViewContent", "content_name": "Open Home Page", "content_category": "Electronics", "content_ids": [], "content_type": "product", "value": 0.00, "currency": "NGN"}]}"""`
            this.$pixel.sendEventToAndroid(jsonData)
          }
        }
      }
    },
    shareContent(i) {
      if (i === 1) {
        if (navigator.share) {
          navigator
            .share({
              title: 'OT.GAME',
              text: 'OT.GAME',
              url: 'https://OT.GAME/#/'
            })
            .catch((err) => {
              console.error(err)
            })
        } else {
          alert('Your browser does not support the Web Share API.')
        }
      }
    },
    getImagePath(char) {
      return this.numberImages[char]
    },
    // addRandomValue() {
    //   // 随机增加整数部分 1-100
    //   const integerRandom = Math.floor(Math.random() * 100) + 1
    //   // 随机增加小数部分 0.01-0.99
    //   const decimalRandom = (Math.floor(Math.random() * 100) / 100).toFixed(2)
    //   // 将小数部分转换为数值
    //   const decimalValue = parseFloat(decimalRandom)
    //   // 更新当前值
    //   this.currentValue += integerRandom + decimalValue
    //   // 确保小数点后两位
    //   this.currentValue = parseFloat(this.currentValue.toFixed(2))
    //   // 保存到 localStorage
    //   localStorage.setItem('savedValue', this.currentValue)
    // },
    // startTimer() {
    //   this.timer2 = setInterval(() => {
    //     this.addRandomValue()
    //   }, 1000)
    // },
    startTimer2() {
      this.timer3 = setInterval(() => {
        this.currentPage++
        if (this.currentPage * this.itemsPerPage >= this.allItems.length) {
          this.currentPage = 0
        }
      }, 3000) // 每 3 秒切换一次
    },
    loadSavedValue() {
      const savedValue = localStorage.getItem('savedValue')
      if (savedValue) {
        // if (savedValue > 99999999) {
        //   this.currentValue = 10029898.87
        // } else {
        this.currentValue = parseFloat(savedValue)
        // }
      }
    },
    gotoRefer() {
      this.$jumpTo('/referFriend')
    },
    getBacks() {
      scrollIntoView(this.$refs.targetElement, {
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 垂直方向对齐方式
      })
    },
    tabSelect() {
      this.allOpen = false
      // this.$router.push({
      //   path: '/category',
      //   query: { gameTab: this.activeTab }
      // })
      // scrollIntoView(this.$refs.targetElement, {
      //   behavior: 'smooth', // 平滑滚动
      //   block: 'start' // 垂直方向对齐方式
      // })
    },
    goVendor(vendor) {
      this.$jumpTo('/category', { vendorCode: vendor.code })
    },
    // 是否展开全部
    openAll(item, index) {
      this.allOpen = true
      this.typeIndex = index
      this.$jumpTo('/category')
      // scrollIntoView(this.$refs.targetElement, {
      //   behavior: 'smooth', // 平滑滚动
      //   block: 'start' // 垂直方向对齐方式
      // })
    },
    async GetHomeGameList() {
      const data = await GetHomeGameList()
      if (data.status === 'ok') {
        this.pgDate = data.content
        // 过滤掉 sortType === 2 的分类（不展示）
        this.pgDate.dataList = this.pgDate.dataList.filter(item => item.sortType !== 2)
        // 创建一个新数组，将新对象插入到第一个位置

        // 使用 map 和 reduce 合并 types 数组（只合并普通游戏分类，不合并厂商分类）
        const typesArr = this.pgDate.dataList
          .filter((item) => item.sortType !== 1)
          .map((item) => item.types)
          .reduce((acc, current) => acc.concat(current), [])

        const newList = [
          {
            name: 'Lobby',
            icon: require('@/assets/img/common/all_home.png'),
            types: typesArr
          },
          ...this.pgDate.dataList
        ]
        this.pgDate.dataList = newList
        // this.pgDate.dataList.splice(0, this.pgDate.dataList.length, ...newList) // 替换原数组

        // this.pgDate.dataList.forEach((i) => {
        //   i.types.sort((a, b) => a.order - b.order)
        // })

        // let newArr = this.pgDate.dataList[0].types.filter(
        //   (i) => i.code === '3000602'
        // )
        // this.isOtgame = newArr.flatMap((item) =>
        //   item.games.filter((game) => game.gameName === 'Lucky Ball')
        // )
        // let newDataList = JSON.parse(
        //   JSON.stringify(this.pgDate.dataList[0].types)
        // )
        // this.pgDate.dataList[0].homeIcon = require('@/assets/img/common/all_home.png')
        // // 使用 Vue.set 确保响应式更新
        // for (let i = 0; i < newDataList.length; i++) {
        //   this.$set(this.pgDate.dataList, i + 1, {
        //     homeIcon: newDataList[i].homeIcon,
        //     icon: newDataList[i].icon,
        //     name: newDataList[i].name,
        //     types: [newDataList[i]]
        //   })
        // }
        // this.pgDate.dataList = this.pgDate.dataList.map((lobby) => ({
        //   ...lobby,
        //   gamesNumber: lobby.types.reduce(
        //     (total, type) => total + type.games.length,
        //     0
        //   ) // 计算所有 games 的总长度
        // }))
        // this.$bus.$emit('tab-list', this.pgDate.dataList)
      }
    },
    async GetHomeWinningGameList() {
      this.loading = true // 开始加载
      const data = await GetHomeWinningGameList()
      if (data.status === 'ok') {
        this.winDate = data.content
        this.allItems = data.content.dataList
        this.loading = false // 请求成功，关闭加载
        this.winnerOffsetX = -(
          this.winnerList.length *
          (this.winnerItemWidth + this.winnerGap)
        )
        this.$nextTick(() => this.winnerStartAutoplay())
      }
    },
    // 中奖轮播：将 offset 限制在中间段，避免露馅
    winnerClampOffset() {
      const list = this.winnerList
      if (!list.length) return
      const w = this.winnerItemWidth + this.winnerGap
      const segment = list.length * w
      if (this.winnerOffsetX >= 0) {
        this.winnerNoTransition = true
        this.winnerOffsetX = -segment
        this.$nextTick(() => {
          this.winnerNoTransition = false
        })
      } else if (this.winnerOffsetX <= -segment * 2) {
        this.winnerNoTransition = true
        this.winnerOffsetX = -segment
        this.$nextTick(() => {
          this.winnerNoTransition = false
        })
      }
    },
    onWinnerTouchStart(e) {
      this.winnerStopAutoplay()
      this.winnerTouchStartX = e.touches[0].clientX
    },
    onWinnerTouchMove(e) {
      const dx = e.touches[0].clientX - this.winnerTouchStartX
      this.winnerTouchStartX = e.touches[0].clientX
      this.winnerOffsetX += dx
    },
    onWinnerTouchEnd() {
      this.winnerClampOffset()
      this.winnerStartAutoplay()
    },
    winnerStartAutoplay() {
      this.winnerStopAutoplay()
      if (!this.winnerList.length) return
      const w = this.winnerItemWidth + this.winnerGap
      this.winnerAutoplayTimer = setInterval(() => {
        this.winnerOffsetX -= w
        this.winnerClampOffset()
      }, 3000)
    },
    winnerStopAutoplay() {
      if (this.winnerAutoplayTimer) {
        clearInterval(this.winnerAutoplayTimer)
        this.winnerAutoplayTimer = null
      }
    },
    goToDetail(i) {
      if (i === 0) {
        this.$jumpToh('/vipSignIn')
      } else if (i === 1) {
        this.$jumpTo('/cashBack')
      } else if (i === 2) {
        this.$jumpTo('/signIn')
      } else if (i === 3) {
        this.$jumpTo('/share')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.otag-gg {
  // background: url('../../assets/img/otgame/gonggao_07.png') no-repeat;
  height: 45px;
  background-size: 100% 100%;
}
.image-bottom—container {
  display: flex; /* 使用 Flex 布局 */
  flex-direction: row; /* 水平排列 */
  justify-content: space-between; /* 可选值：space-between / center / space-around / space-evenly */
  align-items: center; /* 垂直居中 */
  padding-bottom: 15px;
}
.image—logo {
  width: auto;
  height: 30px;
  object-fit: cover;
  border-radius: 0px;
}
.image-bottom—text {
  font-size: 12px;
  word-wrap: break-word;
}
.content {
  // padding-top: 60px;
  margin-bottom: 12%;
  // background: @background-color;
  // background: url('../../assets/img/page_bg2.png') no-repeat center center;
  background-size: cover;
  // height: 100vh;
  // overflow-y: scroll;
  /* 隐藏滚动条样式 */
  &::-webkit-scrollbar {
    display: none;
  }
  ::v-deep .van-overlay {
    z-index: 1999 !important;
  }
  .notice-swipe {
    height: 20px;
    line-height: 20px;
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
  }
}
.content-swiper {
  width: 100%;
  text-align: center;
}
// ====== BANNER SWIPER ======
.banner-swiper {
  padding: 0 12px;
  margin-bottom: 10px;

  &__swipe {
    border-radius: 10px;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    display: block;
    border-radius: 10px;
  }

  ::v-deep .van-swipe__indicator--active {
    background: #24ee89;
    width: 16px;
    border-radius: 4px;
  }

  ::v-deep .van-swipe__indicator {
    background: rgba(255, 255, 255, 0.4);
  }
}
.content-swiper--img {
  border-radius: 10px;
  width: 100%;
  margin-top: 10px;
  padding: 0 15px;
}
.content-serach {
  margin: 10px auto 10px;
  width: 94%;
  scroll-margin-top: 32px; /* 向上偏移 50px */
}
.search-entry-wrap {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #2d3242;
  border-radius: 10px;
  cursor: pointer;
  .search-entry-icon {
    flex-shrink: 0;
    margin-right: 8px;
    opacity: 0.9;
  }
  .search-entry-placeholder {
    color: #9da7bc;
    font-size: 14px;
  }
}
.custom-field {
  padding: 5px;
  background: @cont-bg;
  border-radius: 10px;
  border: none;
  ::v-deep .van-field__control {
    /* 修改输入框的字体颜色 */
    color: #ffffff;
  }
}
.van-cell {
  color: #ffffff;
}
::v-deep .van-field__value {
  caret-color: #a665d8; /* 输入框光标颜色 */
}
.custom-button {
  padding: 16px 5px;
  background-color: @primary-color; /* 按钮背景颜色 */
  color: #ffffff; /* 按钮文字颜色 */
  border: none; /* 去除边框 */
  border-radius: 8px;
  font-size: 12px;
}
.content-winner {
  width: 94%;
  margin: 15px auto 0;
}
/* 自定义中奖轮播：从左到右、可左右滑动、无限循环 */
.winner-carousel-wrap {
  margin-top: 15px;
  overflow: hidden;
  touch-action: pan-y pinch-zoom;
  height: 145px;
}
.winner-carousel-track {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  transition: transform 0.3s ease-out;
}
.winner-carousel-no-transition {
  transition: none !important;
}
.winner-carousel-item {
  flex-shrink: 0;
  width: 65px;
  margin-right: 10px;
}

.content-winne--swiper {
  .swiper-slide {
    text-align: center;
    font-size: 10px;
  }
  .swiper-slide .swiper-slide--img {
    border-radius: 8px;
    height: 80px;
    width: 120px;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
.tab-icon {
  width: 25px; /* 图标宽度 */
  // height: 35px; /* 图标高度 */
  // vertical-align: middle; /* 垂直居中对齐 */
}

.content-tab {
  margin: 0 auto;
  width: 100%;
}
/* 自定义选中状态的 Tab 样式 */
::v-deep .van-tab--active {
  color: #ffffff !important;
  // background: url(../../assets/img/home/tab-bg.png) no-repeat !important;
  // background-size: cover !important;
  // background: linear-gradient(to bottom, #172f4d, #172943, #17233a) !important;
  // border: 1px solid #2283f6 !important;
}

// ::v-deep .van-tab--active ::after {
//   content: '';
//   position: absolute;
//   left: 0;
//   right: 0;
//   bottom: 0px;
//   margin: 0 auto;
//   width: 35px;
//   height: 3px; /* 设置渐变阴影的高度 */
//   background: linear-gradient(
//     to right,
//     #401c2d,
//     #a7203c,
//     #5d1e31
//   ); /* 设置渐变效果 */
// }

::v-deep .van-tabs__nav--line.van-tabs__nav--complete {
  // background-color: @background-color;
  // background: url(../../assets/img/home/tab-cont.png) no-repeat !important;
  background: transparent !important;
  // background-size: 100% 100%;
  color: #ffffff !important;
  padding-left: 0;
  padding-right: 0;
}
::v-deep .van-sticky--fixed {
  top: 50px;
}
::v-deep .van-tabs__wrap--scrollable {
  // background: #f3f5f9;
  // padding: 0px 15px 0px 0;
  padding: 0 10px;
}
// ::v-deep .van-tabs__wrap--scrollable:first-child {
//   margin-left: 12px;
// }
.tab-title-column {
  background: #363849;
  padding: 3px 5px;
  border-radius: 6px;
  color: #9294a9;
  white-space: nowrap;
  width: 80px;
  overflow: hidden;
}
.tab-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 50px;
}
.vendor-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 10px 0;
}
.vendor-grid__item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
}
.vendor-grid__icon {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: contain;
  background: #2a2c3e;
}
.vendor-grid__name {
  margin-top: 6px;
  font-size: 11px;
  color: #c4c4c4;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  // background-color: #00000000;
  // min-width: 52px;
  padding: 0 4px !important;
  border-radius: 15px;
  text-align: center;
  // font-weight: bold;
  // background-image: radial-gradient(
  //   circle at 50% 50%,
  //   #7041f3 0%,
  //   rgba(112, 65, 243, 0.25) 50%
  // );
  // border: 1px solid rgba(255, 255, 255, 0.08);
  // flex-flow: column !important;
  // justify-content: space-between !important;
  // height: 100%;
  // margin-left: 5px;
}
// ::v-deep .tab-title-column {
//   height: 70px !important;

//   .tab-text {
//     width: 50px;
//     word-wrap: break-word;
//   }
// }
::v-deep .van-tabs__line {
  display: none;
}
// ::v-deep .van-tab {
//   padding: 10px 10px;
//   height: 48px;
// }
.content-tab--ct {
  margin: 0 0 5px;
  justify-content: space-between;
}
.content-tab--ctt {
  // background-color: #262e3d;
  border-radius: 10px;
  padding: 6px 9px;
}
.content-tab--ctt2 {
  background: url(../../assets/img/home/selecct-game.png) no-repeat; /* 浅蓝色透明背景 */
  background-size: 100% 100%;
  min-width: 42px;
  text-align: center;
  padding: 5px 0;
  color: @font-color;
}
// ::v-deep .van-tabs__wrap {
//   height: 68px;
// }
::v-deep .van-tab {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
// .tab-title-column {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
// }

.content-bbttom {
  width: 100%;
  // padding-bottom: 10%;
  // padding-top: 12px;
  // margin-top: 3%;
  // background: url('../../assets/img/home/home_bottom_bg.jpg') no-repeat;
  // height: 435px;
  // background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  padding-bottom: 15px;
}

.content-line {
  margin: 15px auto;
  width: 100%;
  height: 1px;
  background: #303243;
  opacity: 0.7;
}
.content-bbttom--3 {
  width: 88%;
  margin: 2% auto 0;
}
.item-sider {
  width: 65px; /* 单个元素的宽度 */
  // height: 85px; /* 单个元素的高度 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  ::v-deep .van-image__img {
    border-radius: 8px;
  }
}
.my-swipe {
  margin-top: 15px;
  position: relative;
  height: 108px;
  text-align: center;
}
.item-sider--t {
  position: relative;
  bottom: 0;
  font-size: 9px;
  text-align: center;
}
.jackpot-c {
  padding: 2.5%;
}
.jackpot-bg {
  position: relative;
  margin-top: 5px;
  background-image: url('../../assets/img/home/home_jack_pot_item_bg.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  height: 140px;
  padding: 30px 0 0 10px;
}
.jackpot-bg--i {
  position: absolute;
  width: 120px;
  left: 63px;
  top: -3px;
}
.jackpot-bg--i2 {
  position: absolute;
  width: 67px;
  left: 89px;
  top: 0;
}
.prize-pool {
  font-size: 30px;
}
.rolling-number {
  font-weight: bold; /* 加粗 */
  font-size: 32px; /* 字体大小 */
  letter-spacing: 5px; /* 字间距 */
}
.rolling-number span {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 24px;
  white-space: nowrap;
  animation: roll 1s steps(3) infinite;
}
@keyframes roll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
.game-bg {
  background-image: url('../../assets/img/home/home_six_game.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  height: 50px;
  width: 60%;
  margin-top: 10px;
  padding-left: 5px;
  img {
    width: 30px;
    margin: 5px 5px 0 0;
  }
}
.search-content {
  padding: 3%;
  ::v-deep .van-image__img {
    border-radius: 11px;
  }
  .resher-content--b {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap row;
  }
  .resher-content--img {
    width: 31.2%;
    // height: 145px;
    margin-bottom: 10px;
  }
  .resher-content--b > div:last-child {
    margin-right: 31.2%; /* 或者padding-right */
  }
}
::v-deep .custm-swiper {
  width: 100%;
  .van-swipe__indicator {
    width: 13px;
    border-radius: 12px;
    color: transparent !important;
  }
  .van-swipe__indicator--active {
    width: 35px;
    color: transparent !important;
  }
}
.content-c2 {
  width: 88%;
  margin: 8px auto 0;
  text-align: center;
  img {
    margin-bottom: 5px;
    width: 42px;
  }
}
.content-c3--Copy {
  background: url('../../assets/img/common/top-3-game.png') no-repeat; /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  width: 92%;
  height: 70px;
  margin: 0 auto 18px;
  padding: 10px 20px;
}
.content-c3 {
  background: url('../../assets/img/common/top-2-game.png') no-repeat; /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  width: 92%;
  height: 70px;
  margin: 0 auto 18px;
  padding: 10px 20px;
  .content-c3--f {
    background: #f8da29;
    color: #000000;
    padding: 5px;
    text-align: center;
    border-radius: 15px;
    width: 210px;
    font-size: 10px;
    font-weight: bold;
    margin-top: 3px;
  }
}
.content-jack {
  .content-jack--c {
    margin-top: 12px;
    margin-bottom: 12px;
    width: 100%;
    .content-jack--i {
      background: url('../../assets/img/common/jiangc-1.png') no-repeat center
        center;
      background-size: 100% 100%;
      text-align: center;
      height: 103px;
      padding-top: 48px;
      width: 90%;
      margin: 0 auto;
    }
  }
}
.number-display {
  display: flex;
  align-items: flex-end;
  gap: 5px; /* 调整图片间距 */
  justify-content: center;
}

.number-image {
  // width: 14px;
  height: 20px;
  object-fit: cover;
}
.font-bd {
  width: 6px;
  height: 7px;
}
.jackt-temp {
  width: 94%;
  margin: 0 auto;
}
.jackt-temp2 {
  width: 94%;
  margin: 5px auto 0;
  background: #1d2e4f;
  border-radius: 7px;
  padding: 8px 10px;
}
.content-tab--s {
  ::v-deep .van-loading {
    background: transparent;
  }
}
.notice-bar {
  display: flex;
  align-items: center;
  margin: 10px;
  font-size: 14px;
  color: #000;
}

.notice-text-wrapper {
  display: flex;
  align-items: center;
  background-color: #edf9f5a8;
  margin-right: 10px;
  border-radius: 6px;
  padding: 6px;
  flex: 1;
  overflow: hidden;
  position: relative;
}

.inner-icon {
  width: 18px;
  height: 14px;
  flex-shrink: 0;
  margin-right: 6px;
}

.scroll-container {
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  position: relative;
}

.notice-text {
  display: inline-block;
  white-space: nowrap;
  font-weight: 500;
  animation: scroll-text 10s linear infinite;
  animation-play-state: running !important;
}

.notice-text-wrapper:hover .notice-text {
  animation-play-state: paused;
}

@keyframes scroll-text {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.news-icon {
  height: 21px;
  width: auto;
  flex-shrink: 0;
}
.custom-popup2 {
  width: 86%;
  text-align: center;
  background-color: transparent; /* 设置背景色 */
  // z-index: 2004 !important;
  .cont-redim {
    // padding-top: 330px;
    background: url(../../assets/img/common/syhd.png) no-repeat;
    background-size: 100% 100%;
    height: 420px;
    border-radius: 15px;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: #4981f4 !important;
  }
  .van-overlay {
    z-index: 2001 !important;
  }
}
.counw-cont {
  display: flex;
  justify-content: center;
  .counw-cont-bg {
    background: linear-gradient(to bottom, #fe1300, #ff4a01, #ff8a00);
    font-weight: bold;
    padding: 8px 20px;
    border-radius: 8px;
    font-size: 25px;
    color: #ffffff;
  }
  .counw-cont-bg2 {
    padding: 8px 20px;
    color: #ffffff;
  }
}
// .mask-cont {
//   background: url(../../assets/img/home/mask_bg.png) no-repeat;
//   background-size: 100% 100%;
//   background: linear-gradient(to right, #14141e, #14141e, #14141e, #3a1c2b);
//   padding-bottom: 10px;
// }
// .content-swiper-bg {
//   background: url('../../assets/img/home/bg-show2.png') no-repeat;
//   background-size: 100% 100%;
// }
.van-notice-bar {
  // height: 32px;
  width: 93%;
  border-radius: 10px;
  margin-left: 3%;
  padding: 0 10px;
  background: rgba(255, 255, 255, 0.04);
}
.bot-swiper-b {
  ::v-deep .van-swipe__indicator--active {
    width: 25px !important;
    border-radius: 10px !important;
  }
  ::v-deep .van-swipe__indicator {
    width: 12px;
    border-radius: 10px !important;
  }
  ::v-deep .van-swipe__indicators {
    bottom: 0px;
  }
}
.content-bbttom--1 {
  text-align: center;
}
.content-bbttom--1 :first-child img {
  width: 138px;
  height: 28px;
  margin-top: 15px;
}
.content-bbttom--1 :nth-child(2) img {
  width: 40px;
  height: 50px;
}
.content-bbttom--1 :nth-child(3) img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
}
.select-Men {
  background: #468dff !important;
  color: #ffffff !important;
  border-bottom: 1px solid #468dff !important;
}
.a-ccc {
  color: #ffffff !important;
  background: #930df3;
}
/* PC 端样式 */
@media (min-width: 769px) {
  .cont-redim {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .custom-popup2 {
    width: 370px !important;
  }
  ::v-deep .van-sticky--fixed {
    top: 110px !important;
  }
}
</style>
